module.exports = __webpack_public_path__ + "img/랭킹모니터링추가.5a1ae70a.png";